/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { defaultsDeep, identity } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { ENTITY_TYPES } from '../../../services/EntityService';

export const filterId = 'Radio';
export const filterTitle = t`Radio`;
export const entityType = ENTITY_TYPES.RADIO;

export function useRadio() {
    return useEntity(filterId);
}

export function useRadioName() {
    return useEntityName(filterId);
}

const dataSourceParams = {
    entityFields: ['name'],
};

function RadioFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType, dataSourceParams, showHeaders: true };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

RadioFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

RadioFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: {
                target: '/radio-detail',
                mappedFilterParams: {
                    [filterId]: identity,
                },
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(RadioFilter);
